import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export default function MintItem({ contract }) {
    const history = useHistory();
    const { url } = useRouteMatch();
    const bcgLink = contract?.customImage ?? contract.image
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                width: "100%",
                height: "100%",
                background: "#B3B3B3",
                borderRadius: "16px",
                padding: "1.5rem",
                backgroundImage: () => `url(${bcgLink})`,
                backgroundSize: "cover",
            }}
            onClick={() => history.push(`${url}/${contract._id}`)}
        >
            <Typography sx={{
                backgroundColor: "rgba(255, 255, 255, 0.5)", 
                fontWeight: "bold",
                borderRadius: "0.5rem",
                padding: " 0 1rem",
                }} component="h3">
            Contract {contract.type}
            </Typography>
            <Typography
                sx={{
                    fontFamily: "Circular Std",
                    fontStyle: "normal",
                    fontWeight: "bold",
                    fontSize: "38px",
                    lineHeight: "48px",
                    color: "#040405",
                    borderRadius: "0.5rem",
                    padding: " 0 1rem",
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                }}
                component="div"
            >
                {contract?.customName ?? contract.name}
            </Typography>
        </Box>
    );
}
